import React, {Component} from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';
import { translate } from 'react-i18next';
import {Table} from 'react-bootstrap';
import pdfMake from "pdfmake/build/pdfmake";
const Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');

class QuestionsResponse extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.getQuestions = this.getQuestions.bind(this);
        this.onSave = this.onSave.bind(this);
        this.clear = this.clear.bind(this);
        this.getResponse = this.getResponse.bind(this);
        this.generatePdf = this.generatePdf.bind(this);

        this.state = {
            no_offer:"",
            id:"",
            date:"",
            questions:[],
            questionary_id:"",
            disable:false,
            date_response:"",
            donor:"",
            show:false,
            date_hour:"",
			medical:"",
        }

    }

    componentDidMount(){
        if(this.props.location.pathname !== '/interview'){
            this.setState({disable: true});

            var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

            this.setState({
                medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
                        (medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
            });

            fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
                method: 'get',
                headers: new Headers({
                   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
                   'Accept': 'application/json',
                    'Content-Type': 'application/json',
                })
            })
            .then(response => response.json())
            .then(response => {
                var aux = response.split('|');
                var hours = this.getHourFormat(aux[1]);
    
                this.setState({
                    date_hour:aux[0]+' '+hours,
                });
            })
        }
    }

    getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    onSearch(){
        this.props.waiting.handleShow('Buscando...');
        this.getQuestions();
    }

    getQuestions(){
        fetch(Config.default.apiGateway.URL+'questionaries/by_center/'+sessionStorage.getItem('health_facilities_id'),{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    swal('Error', msg, 'error');
                });
            }
        }).then(async response => {
            if(response !== undefined){
                var table = [];

                response.questions.forEach((question)=>{
                    var obj = {
                        ask_id:question.ask_id,
                        title: question.description,
                        columns:[],
                        rows:[],
                        required:false,
                    };

                    if(question.type === 'AGRUPADA'){
                        obj.columns = [{title:""}];
                    }

                    question.blocks.forEach((block, i)=>{
                        var row = {
                            block_id: question.type === 'SIMPLE' ? "" : block.block_id,
                            label: question.type === 'SIMPLE' ? "" : block.label,                            
                            sections:[]
                        };

                        question.sections.forEach((section)=>{
                            var item = {
                                section_id: section.section_id,
                                sections:[],
                                value:"",
                                type:section.type
                            };
                            
                            if(section.section_options.length > 0){
                                section.section_options.forEach((option)=>{
                                    item.sections.push({
                                        value: option.value,
                                        label: option.label,
                                        checked:false
                                    });
                                });
                            }else{                                
                                item.value = "";
                                item.min_value = section.min_value;
                                item.max_value = section.max_value;
                            }

                            row.sections.push(item);
                        });

                        obj.rows.push(row);
                    });

                    if(question.blocks.length === 0){
                        var row = {
                            block_id: "",
                            label: "",
                            sections:[]
                        };

                        question.sections.forEach((section)=>{
                            var item = {
                                section_id: section.section_id,
                                sections:[],
                                value:"",
                                type:section.type
                            };
                            
                            if(section.section_options.length > 0){
                                section.section_options.forEach((option)=>{
                                    item.sections.push({
                                        value: option.value,
                                        label: option.label,
                                        checked:false
                                    });
                                });
                            }else{                                
                                item.value = "";
                                item.min_value = section.min_value;
                                item.max_value = section.max_value;
                                item.label = section.subtitle;
                            }

                            row.sections.push(item);
                        });

                        obj.rows.push(row);
                       
                    }

                    question.sections.forEach((section, i)=>{ 
                        if(section.section_options.length > 0){
                            section.section_options.forEach((option)=>{                                
                                if(question.type === 'AGRUPADA'){
                                    obj.columns.push({
                                        title:option.label
                                    });
                                }
                            });
                        }else{
                            if(question.type === 'AGRUPADA'){
                                obj.columns.push({
                                    title:section.subtitle
                                });
                            }
                        }
                    });

                    table.push(obj);
                })  


                await this.setState({questions: table, questionary_id:response.id});

                if(this.state.disable){
                    await this.getResponse();
                }
                
            }
        })
    }

    getResponse(){
        fetch(Config.default.apiGateway.URL+'offer_questionnaire?offer_id='+this.state.no_offer,{
            method:'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Accept'        : 'application/json',
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            this.props.waiting.handleClose();
            if(res.ok){
                return res.json();
            }else{
                res.text().then((msg) => {
                    var res = '';
                    try{
                        res = JSON.parse(msg);
                    }catch(e){
                        res = {Message: msg};
                    }
                    
                    swal('Error', res.Message, 'error');
                });
            }
        }).then(response => {
            if(response !== undefined){
                var questions = this.state.questions;
                questions.forEach((q)=>{
                    var index = response.questionnaire_response.findIndex(obj => obj.ask_id === q.ask_id);

                    if(index !== -1){                        
                        q.rows.forEach((row)=>{
                            if(row.block_id !== null && row.block_id !== ""){    
                                response.questionnaire_response[index].responses.forEach(res => {
                                    if(res.block_id === row.block_id){
                                        row.sections.forEach(item => {                                        
                                            if(item.section_id === res.section_id){
                                                item.sections.forEach(section => {
                                                    if(section.value === res.value){
                                                        section.checked = true;
                                                    }
                                                });

                                                if(item.sections.length === 0){
                                                    item.value = res.value;
                                                }
                                                
                                            }
                                        })

                                        
                                    }
                                })
                            }else{
                                response.questionnaire_response[index].responses.forEach(res => {
                                    row.sections.forEach(item => {                                        
                                        if(item.section_id === res.section_id){
                                            item.sections.forEach(section => {
                                                if(section.value === res.value){
                                                    section.checked = true;
                                                }
                                            });

                                            if(item.sections.length === 0){
                                                item.value = res.value;
                                            }
                                            
                                        }
                                    })
                                })
                            }
                        })
                    }
                });

                this.setState({
                    show:true,
                    questions: questions,
                    self_exclusion: response.self_exclusion,
                    id: response.offer_id,
                    date_response: moment(response.timestamp).format('DD/MM/YYYY HH:mm:ss'),
                    donor: response.donor_name,
                    date: response.timestamp_date !== undefined ? moment(response.timestamp_date).format('DD/MM/YYYY')+' '+moment(response.timestamp_hour, 'HH:mm:ss.sssssss').format('HH:mm') : ""
                });
            }
        })
    }

    onSave(e){
        e.preventDefault();
        var obj = {
            questionary_id: this.state.questionary_id,
            offer_id: this.state.id,
            questionnaire_response:[]
        };

        this.state.questions.map((q)=>{
            var control = document.getElementById(q.id);
            var item = {};

            if(control !== null){
                item = {
                    ask_id: q.id,
                    answer: control.value
                };

                if(control.value !== ""){
                    obj.questionnaire_response.push(item);
                }
            }

            return q;
        });

        if(this.state.exclusion_by_questionnaire.value === 'YES'){
            obj.self_exclusion = this.state.self_exclusion;
        }else{
            obj.self_exclusion = null;
        }

        if(this.isValidForm()){
            if(obj.questionnaire_response.length > 0){
                this.props.waiting.handleShow('Guardando...');
                fetch(Config.default.apiGateway.URL+'offer_questionnaire',{
                    method:'POST',
                    body:JSON.stringify(obj),
                    headers: new Headers({
                        'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'        : 'application/json',
                        'Content-Type'  : 'application/json'
                    })
                }).then(res => {
                    this.props.waiting.handleClose();
                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then((msg) => {
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined){
                        swal('Correcto', 'Los datos se guardaron correctamente', 'success');
                        this.clear();
                    }
                })
            }else{
                swal('Error', 'Debe contestar por lo menos una pregunta', 'error');
            }
        }else{
            swal('Error', 'Campos incompletos', 'error');
        }
    }

    isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    var vacio = false;

	    inputs.forEach(input => {
            if(input.required){
                const isInputValid = this.showCtrlError(input.id);
             
                if (!isInputValid) {                    
                    vacio = true;
                }
            }
	    });

	    if(vacio){
	    	isFormValid = false;
	    }

	    return isFormValid;
    }

    showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);

        if(control !== null){
            if(control.required){
                if(control.value === ""){
                    control.classList.add('error');
                    res = false;
                    
                }else{
                    if(control.className.includes('error')){
                        control.classList.remove('error');
                        
                    }
                    res = true;
                }

            }
        }
		
		return res;		
	}
    
    clear(){
        this.setState({
            no_offer:"",
            id:"",
            date:"",
            questions:[],
            questionary_id:"",
            date_response:""
        });
    }

    generatePdf(e){
        e.preventDefault();

        var fechas = moment().format("DD/MM/YYYY");
		
		var doc = {
			content:[
				{
					image: this.props.header_document,
					alignment:'center',
					width:this.props.w_head
				},
				{
					text:'Respuestas de encuesta', style:'title', margin:[0,10,0,12]
				},
				{
					text: fechas, margin:[10,0,0,10]
                },
                {
                    columns:[
                        {text:'Id:', width:'20%'},
                        {text:this.state.id}
                    ]
                },
                {
                    columns:[
                        {text:'Fecha:', width:'20%'},
                        {text:this.state.date}
                    ]
                },
                {
                    columns:[
                        {text:'Donador:', width:'20%'},
                        {text:this.state.donor}
                    ]
                },
                {
                    columns:[
                        {text:'Respondido el:', width:'20%'},
                        {text:this.state.date_hour}
                    ]
                }				
			],
			defaultStyle:{fontSize:6.5},
			pageMargins:40,
			footer:{text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]},
			pageOrientation:'portrait',
			pageSize:'A4',
			styles:{
                title:{alignment: 'center', fontSize: 15},
				tableBodyEven:{},
				tableBodyOdd:{fillColor:'#f3f3f3'},
				tableHeader:{bold:true, fontSize:6.5, color:'white', fillColor:'#2d4154', alignment:'center'}
			}

        };
        
        this.state.questions.forEach((question)=>{
            var title = {
                text: question.title, alignment:'center', fontSize:10, margin:[0, 10, 0, 10]
            };

            doc.content.push(title);

            var content = {
				layout:'noBorders',
				table:{
					body:[],
					headerRows:1,
					widths:[]
				}
			};
            var body = [];
            
            if(question.columns.length > 0){
                var widths = ['35%'];
                var last = question.columns[question.columns.length - 1].title.length;
                if(last > 10){
                    last = '20%';

                    var w = 45 / (question.columns.length - 2);

                    for(var i = 1; i < (question.columns.length - 1); i++){
                        widths.push(w+'%');
                    }

                    widths.push(last);
                }else{
                    var w = 65 / (question.columns.length - 1);

                    for(var i = 1; i < question.columns.length; i++){
                        widths.push(w+'%');
                    }

                }

                content.table.widths = widths;

                question.columns.forEach(column => {
                    body.push({text: column.title, style:'tableHeader'});
                });
                    
                content.table.body.push(body);
                
            }else{
                content.table.headerRows = 0;
                
                question.rows.forEach((row)=>{
                    row.sections.forEach(section => {
                        if(section.sections.length === 2){
                            content.table.widths = ['50%', '50%'];
                        }else{
                            content.table.widths = ['100%'];
                        }
                    });
                });                
            }

            question.rows.forEach((row, i)=>{
                body = [];
                if(row.label !== ""){
                    body = [{text:row.label, style:i % 2 === 0 ? 'tableBodyOdd' : 'tableBodyEven'}];
                }                
                
                row.sections.forEach(section => {
                    section.sections.forEach((s)=>{
                        body.push({text: s.checked ? 'X' : '', alignment:'center', style:i % 2 === 0 ? 'tableBodyOdd' : 'tableBodyEven'});
                    });

                    if(section.type === 'OPEN'){
                        body.push({text:section.value, style:i % 2 === 0 ? 'tableBodyOdd' : 'tableBodyEven'});
                    }
                    
                });

                content.table.body.push(body);

                body = [];
                if(row.sections.length < 2){
                    var index = row.sections.findIndex(obj => obj.type === 'YES_NO');

                    if(index !== -1){
                        body.push(
                            {text:'SI', alignment:'center'},
                            {text:'NO', alignment:'center'}
                        );
                    }
                }

                if(body.length > 0){
                    content.table.body.push(body);
                }
                
            });
            

            doc.content.push(content);
            
        })
        
        pdfMake.createPdf(doc).download('Respuestas de encuesta.pdf');
        

    }

    render(){
        const {t} = this.props;

        return(
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page" >
                        {session} ->
                        {t('sidebar.nav.donors.MAIN')} -> 
                        Encuesta
                    </h5>
                </div>
                <Help
                    {...this.props}
                    menu={"help_donors"} 
                    submenu={"help_offers_questionary"}  />
                
                <div className="col-xs-12">
                    <div className="col-xs-12">
                        <div className="col-xs-12 col-sm-2">
                            <span className="span-min">Número de ofrecimiento</span>
                            <input type="number" className="form-control input-sm hour-input" 
                                name="no_offer" id="no_offer" value={this.state.no_offer} 
                                onChange={(e)=>this.handleChange(e)}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-1" style={{marginTop:20}}>
                            <button className="btn btn-info" onClick={()=>this.onSearch()}>Buscar</button>
                        </div>
                    </div>
                    {this.state.id !== "" &&
                        <div className="col-xs-12">
                            <hr />
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-1">
                                    <span className="span-min">Id:</span>
                                </div>
                                <div className="col-xs-12 col-sm-10">
                                    <span>{this.state.id}</span>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-1">
                                    <span className="span-min">Fecha:</span>
                                </div>
                                <div className="col-xs-12 col-sm-10">
                                    <span>{this.state.date}</span>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className="col-xs-12 col-sm-1">
                                    <span className="span-min">Donador:</span>
                                </div>
                                <div className="col-xs-12 col-sm-10">
                                    <span>{this.state.donor}</span>
                                </div>
                            </div>
                            {this.state.disable &&
                                <div className="col-xs-12">
                                    <div className="col-xs-12 col-sm-1">
                                        <span className="span-min">Respondido el:</span>
                                    </div>
                                    <div className="col-xs-12 col-sm-10">
                                        <span>{this.state.date_response}</span>
                                    </div>
                                </div>
                            }
                            
                        </div>
                    }

                    {(this.state.questions.length > 0 && this.state.show) &&
                        <form className="col-xs-12">
                            <hr/>
                            <div className="col-xs-12 form-group">                                
                                <fieldset style={{padding:8}}>
                                    <legend>ENCUESTA</legend>

                                    {this.state.questions.map((q, i)=>                                    
                                        <div className="col-xs-12 col-sm-12 form-group" key={i}>
                                            <Table responsive hover>
                                                <caption style={{textAlign:'center', fontSize:20}}>
                                                    {q.title}
                                                </caption>
                                                <thead>
                                                    <tr>
                                                        {q.columns.map((col, i)=>
                                                            <th key={i} style={{textAlign:'center '}}>
                                                                {col.title}
                                                            </th>  
                                                        )}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {q.columns.length === 0 ?                                                        
                                                        q.rows.map((row, i)=>                                                            
                                                            row.sections.map((item, j)=>
                                                                item.sections.length > 0 ?
                                                                    <tr key={i}>
                                                                        {item.sections.map((section, k)=>
                                                                            <td key={k}>
                                                                                <div onChange={(e)=>this.changeRadio(e)} className="col-xs-12" style={{textAlign:'center'}}>
                                                                                    <input 
                                                                                        type="checkbox" 
                                                                                        checked={section.checked} 
                                                                                        value={section.value} 
                                                                                        name={q.ask_id+'-'+i+'-'+j+'-'+k}
                                                                                        style={{
                                                                                            width:'100%'
                                                                                        }}
                                                                                        disabled
                                                                                    />
                                                                                    <span style={{display:'block'}}>{section.label}</span>
                                                                                </div>
                                                                            </td>
                                                                        )}
                                                                    </tr>
                                                                : 
                                                                    <tr key={j}>
                                                                        <td key={j} colSpan={j > 0 ? row.sections[j - 1].sections.length : 1}>
                                                                            {item.type === 'OPEN' || item.type === 'DATE' || item.type === 'RANGE' || item.type === 'NUMBER' ?
                                                                                <div className={
                                                                                    item.type === 'DATE' ?
                                                                                        "col-xs-12 col-sm-4"
                                                                                    : "col-xs-12"
                                                                                }>
                                                                                    <span style={{display:'block', fontSize:20, marginTop:5}}>{item.label}</span>
                                                                                    <input
                                                                                        type={item.type === 'OPEN' ?
                                                                                            'text'
                                                                                        : item.type === 'RANGE' ?
                                                                                            'range'
                                                                                        : item.type === 'DATE' ?
                                                                                            'date'
                                                                                        :
                                                                                            'number'
                                                                                        }
                                                                                        min={item.type === 'RANGE' ?
                                                                                            item.min_value
                                                                                        : ""
                                                                                        }
                                                                                        max={item.type === 'RANGE' ?
                                                                                            item.max_value
                                                                                        : ""
                                                                                        }
                                                                                        className="form-control" 
                                                                                        style={{resize:'none'}}
                                                                                        value={item.value}
                                                                                        onChange={(e)=>this.changeRadio(e)}
                                                                                        name={q.ask_id+'-'+i+'-'+j+'-'}
                                                                                        disabled
                                                                                    />
                                                                                    
                                                                                </div>
                                                                            :
                                                                                <textarea 
                                                                                    className="form-control" 
                                                                                    style={{resize:'none'}}
                                                                                    rows={5}
                                                                                    value={item.value}
                                                                                    onChange={(e)=>this.changeRadio(e)}
                                                                                    name={q.ask_id+'-'+i+'-'+j+'-'}
                                                                                    disabled
                                                                                ></textarea>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                            )
                                                        )                                                        
                                                    :
                                                        q.rows.map((row, i)=>
                                                            <tr key={i}>
                                                                <td>{row.label}</td>
                                                                {row.sections.map((item, j)=>
                                                                    item.sections.length > 0 ?
                                                                        item.sections.map((section, k)=>
                                                                            <td key={k}>                                                                        
                                                                                <div onChange={(e)=>this.changeRadio(e)} className="col-xs-12" 
                                                                                    style={{textAlign:'center'}}
                                                                                >
                                                                                    <input 
                                                                                        type="checkbox" 
                                                                                        checked={section.checked} 
                                                                                        value={section.value} 
                                                                                        name={q.ask_id+'-'+i+'-'+j+'-'+k}
                                                                                        style={{
                                                                                            width:'100%'
                                                                                        }}
                                                                                        disabled
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                        )
                                                                            
                                                                    :                                                                         
                                                                        <td key={j}>                                                                            
                                                                            <input
                                                                                type={item.type === 'OPEN' ?
                                                                                    'text'
                                                                                : item.type === 'RANGE' ?
                                                                                    'range'
                                                                                : item.type === 'DATE' ?
                                                                                    'date'
                                                                                :
                                                                                    'number'
                                                                                }
                                                                                min={item.type === 'RANGE' ?
                                                                                    item.min_value
                                                                                : ""
                                                                                }
                                                                                max={item.type === 'RANGE' ?
                                                                                    item.max_value
                                                                                : ""
                                                                                }
                                                                                className="form-control" 
                                                                                style={{resize:'none'}}
                                                                                value={item.value}
                                                                                onChange={(e)=>this.changeRadio(e)}
                                                                                name={q.ask_id+'-'+i+'-'+j+'-'}
                                                                                disabled
                                                                            />
                                                                            
                                                                        </td>
                                                                )}
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </fieldset>
                               

                                
                            </div>
                            {!this.state.disable &&
                                <div className="col-xs-12" style={{textAlign:'center'}}>
                                    <button className="btn btn-info" onClick={(e)=>this.onSave(e)}>Guardar</button>
                                </div>
                            }

                            {this.state.show &&
                                <div className="col-xs-12" style={{textAlign:'center'}}>
                                    <button className="btn btn-info" onClick={(e)=>this.generatePdf(e)}>Imprimir</button>
                                </div>
                            }
                        </form>
                    }

                </div>
            </div>
        )
    }
    
}

export default translate('translations')(QuestionsResponse);